module.exports = __webpack_public_path__ + "fd5a608a/img/44000000-0.f94ae6cd.png";